/**
 * Display title for a Purchase Request.
 *
 * Since procurement type forms became user-editable (PR #93481), the
 * `request_title` form field can be removed or renamed by an admin. When that
 * happens, `purchaseRequest.description` is empty and any UI surface that uses
 * it as a heading (ResourceHeader, table column, breadcrumbs) renders blank.
 *
 * This helper guarantees a non-empty, identifying string by falling back to
 * the procurement type name plus the short request id when the user-supplied
 * description is missing.
 */

export interface PurchaseRequestTitleSource {
  id: string
  description?: string | null
  type?: { name?: string | null } | null
}

export function purchaseRequestDisplayTitle(purchaseRequest: PurchaseRequestTitleSource): string {
  const description = purchaseRequest.description?.trim()
  if (description) return description

  const typeName = purchaseRequest.type?.name?.trim()
  const shortId = purchaseRequest.id ? `#${purchaseRequest.id}` : ''
  if (typeName) return shortId ? `${typeName} ${shortId}` : typeName
  return shortId || ''
}
